import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Button,
  Icon,
  Grid,
} from '@material-ui/core'
import {
  ToggleButton,
  ToggleButtonGroup,
} from '@material-ui/lab'
import { withStyles } from '@material-ui/core/styles'
import DatesFilter from '../../../components/filters/DatesFilter'
import TravelersFilter from '../../../components/filters/TravelersFilter'
import PlaceField from '../../../components/forms/PlaceField'
import BudgetFilter from '../../../components/filters/BudgetFilter.js'

class PlanTravel extends Component {
  constructor(props) {
    super(props)

    this.state = props.travel || {
      travelers: {
        adults: 1,
        children: 0,
        infants: 0,
      },
      dates: {
        dates_type: 'cheapest',
        start_date: null,
        end_date: null,
        nights: [2, 4],
      },
      from: null,
      to: null,
      budget: 700,
      currency: props.user && props.user.currency || 'USD',
    }
  }

  handleChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  submitRequest = () => {
    this.props.onUpdated({travel: this.state})
  }

  render() {
    const { classes, user } = this.props
    const { travelers, dates, from, to, budget } = this.state

    return (
      <Fragment>
        <Grid item xs={12} md={8} style={{marginBottom: 10, marginTop: 10}}>
          {/* <Grid item xs={12} className={classes.subtitle} style={{marginTop: 0}}>
            Travelers
          </Grid> */}
          <Grid container className={classes.searchField}>
            <Grid item xs={7} md={8} style={{paddingTop: 5}}>
              <PlaceField
                name="from"
                label="Where from? *"
                autofocus={true}
                placeholder={from && from.length > 0 ? "Where from?" : " "}
                single={true}
                standalone={true}
                defaultValues={[from]}
                onChange={this.handleChange.bind(this)}
                classes={{iconLabel: classes.iconLabel}}
              />
            </Grid>
            <Grid item xs={5} md={3} style={{padding: '5px 5px 5px 5px', borderLeft: '1px solid #f2f2f2'}}>
              <TravelersFilter
                name="travelers"
                adults={travelers && travelers.adults}
                children={travelers && travelers.children}
                infants={travelers && travelers.infants}
                onChange={this.handleChange}
                classes={{iconLabel: classes.iconLabel}}
              >
              </TravelersFilter>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.subtitle} style={{textAlign: 'center'}}>
            {/* Destination */}
            {/* <ToggleButtonGroup size="small" style={{margin: 'auto'}}>
              <ToggleButton value="planning" disableRipple selected={this.state.to_type === 'destination'} classes={{root: classes.buttonOutlined, selected: classes.buttonOutlinedSelected}} onClick={() => this.setState({to_type: 'destination'})}>Choose destination</ToggleButton>
              <ToggleButton value="upcoming" disableRipple selected={this.state.to_type === 'flexible'} classes={{root: classes.buttonOutlined, selected: classes.buttonOutlinedSelected}} onClick={() => this.setState({to_type: 'flexible'})} >Flexible</ToggleButton>
            </ToggleButtonGroup> */}
          </Grid>
          <Grid item xs={12} className={classes.searchField} style={{paddingTop: 5}}>
            <PlaceField
              name="to"
              label="Where to?"
              placeholder={to && to.length > 0 ? "Where to?" : "Flexible"}
              defaultValues={[to]}
              limitTags={3}
              single={true}
              standalone={true}
              onChange={this.handleChange.bind(this)}
              classes={{iconLabel: classes.iconLabel}}
            />
          </Grid>
          {/* <Grid item xs={12} className={classes.searchField} style={{paddingTop: 5}}>
            <BudgetFilter name="budget" budget={this.state.budget} currency={this.state.currency} user={this.props.user} onChange={this.handleChange.bind(this)}/>
          </Grid> */}
          <Grid item xs={12} className={classes.subtitle} style={{textAlign: 'center'}}>
            {/* <ToggleButtonGroup size="small" style={{margin: 'auto'}}>
              <ToggleButton value="planning" disableRipple selected={this.state.dates.dates_type === 'specific'} classes={{root: classes.buttonOutlined, selected: classes.buttonOutlinedSelected}} onClick={() => this.setState({dates: {...this.state.dates, ...{dates_type: 'specific'}}})}>Choose dates</ToggleButton>
              <ToggleButton value="upcoming" disableRipple selected={this.state.dates.dates_type === 'cheapest'} classes={{root: classes.buttonOutlined, selected: classes.buttonOutlinedSelected}} onClick={() => this.setState({dates: {...this.state.dates, ...{dates_type: 'cheapest'}}})} >Flexible</ToggleButton>
            </ToggleButtonGroup> */}
          </Grid>
          <Grid item xs={12} className={classes.searchField} style={{padding: '5px 0px 5px 5px'}}>
              {/* <DayPickerRangeControllerWrapper
                // onDatesChange={this.onDatesChange.bind(this)}
                initialStartDate={this.state.start_date}
                initialEndDate={this.state.end_date}
              /> */}
              <DatesFilter
                name="dates"
                dates_type = {dates && dates.dates_type}
                start_date = {dates && dates.start_date}
                end_date = {dates && dates.end_date}
                nights={dates && dates.nights}
                onChange={this.handleChange}>
              </DatesFilter>
          </Grid>
        </Grid>

        <Grid item xs={12} md={8} style={{margin: 'auto'}}>
          <Button disabled={!(this.state.from) || this.state.isSubmitting} onClick={this.submitRequest} variant="contained" color="primary" size="large" className={classes.buttonBook}>
            {this.state.isSubmitting ?
              <Fragment>Sending...</Fragment>
              :
              <Fragment>Continue<Icon className="material-icons-outlined notranslate" style={{marginLeft: 10}}>east</Icon></Fragment>
            }
          </Button>
        </Grid>
      </Fragment>
    )
  }
}

const styles = theme => ({
  subtitle: {
    fontWeight: 600,
    fontSize: 15,
    marginTop: 0,
    marginBottom: 20,
    textAlign: 'left',
    color: '#828282',
  },
  listItemIcon: {
    color: '#02c39a',
  },
  listItemText: {
    fontSize: 15,
    fontWeight: 600,
    color: '#000',
    maxWidth: '78%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextSecondary: {
    fontSize: 14,
    fontWeight: 600,
    maxWidth: '60%',
    display: 'block',
    overflow: 'hidden',
    // whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextPrice: {
    fontSize: 15,
    fontWeight: 600,
    maxWidth: '70%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    cursor: 'pointer',

    '& .material-icons': {
      color: '#02c39a',
      fontWeight: 300,
      verticalAlign: 'middle',
      margin: '-3px 0px 0px 15px',
    }
  },
  listItemSelected: {
    borderRadius: 15,
    border: '2px solid #02c39a',
  },
  listItem: {
    borderRadius: 15,
    border: '2px solid transparent',

    '&:hover': {
      backgroundColor: '#07c3991a',
    },
  },
  buttonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px 0px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 800,
    padding: 15,
    width: '100%',

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
  searchField: {
    border: '1px solid #f2f2f2',
    borderRadius: 20,
    marginBottom: 10,
  },
  iconLabel: {
    color: '#333',
    fontSize: 13,
    fontWeight: 700,
    marginBottom: -4,
    marginLeft: 5,
  },
  buttonOutlined: {
    // color: '#1bb746',
    float: 'left',
    // marginLeft: 10,
    padding: '10px',
    borderRadius: 25,
    fontWeight: 500,
    border: '1px solid #f5f5f5',
    color: '#333',
    marginTop: 6,
    minWidth: 110,
    backgroundColor: '#f5f5f5',

    '& .material-icons': {
      marginRight: 5,
      color: '#777',
      fontWeight: 500,
      padding: 0,
    },

    '&:hover': {
      backgroundColor: '#f2f2f2',
      border: '1px solid transparent',
    },

    '&:not(:first-child)': {
      marginLeft: 0,
    },

    '&:hover .material-icons': {
      color: '#333',
    },
  },
  buttonOutlinedSelected: {
    backgroundColor: '#f5f5f5 !important',
    fontWeight: 800,
    color: '#333 !important',
    padding: '5px 7px',
    minWidth: 110,

    '& .material-icons': {
      color: '#02c39a !important',
    },

    '&:hover': {
      color: '#333',
    },

    '&:hover .material-icons': {
      color: '#333',
    },

    '& > .MuiToggleButton-label': {
      borderRadius: 25,
      backgroundColor: '#fff',
      padding: '4px 10px',
      boxShadow: '0px 3px 3px -2px rgb(0 0 0 / 5%), 0px 3px 4px 0px rgb(0 0 0 / 5%), 0px 1px 8px 0px rgb(0 0 0 / 5%)',
    },
  },
})

export default withRouter(withStyles(styles)(PlanTravel))
